module.exports = __webpack_public_path__ + "static/img/hb_28-min.11e14f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_28-min.png
// module id = szli
// module chunks = 1